
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.49 37.51a1.4 1.4 0 01-2 2L20 22 2.49 39.49a1.4 1.4 0 01-2-2L18 20 .51 2.49a1.4 1.4 0 012-2L20 18 37.51.51a1.4 1.4 0 012 2L22 20z","fill":"#434c56"}})])
          )
        }
      }
    